import ProjectCard from "../PageLayout/ProjectCard";
import ProjectHeader from "../Projects/ProjectHeader";
import { ProjectType } from "../Utils/ProjectType.ts";
import sharedStyles from "./music-shared.module.css"



export default function Valentine() {


    return (
        <ProjectCard projectName={"My Funny Valentine"} >

            <ProjectHeader title={"MY FUNNY VALENTInE"} subTitle={"Jan / Frank"} projectType={ProjectType.Music} />

            <p>Chet Baker is another jazz artist who really inspires me. I had a lot of fun working on this one with Frank, who brought his own spin inspired by Bill Henderson’s version of the song.</p>

            <iframe className={sharedStyles.video} src="https://www.youtube.com/embed/dHBtId615JE" title="My Funny Valentine (Chet Baker Inspired Jazz Cover) by Jan and Frank" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>



        </ProjectCard>
    )
}